import { Button as AntdButton } from 'antd';
import { createGuardedComponent } from '../../provider/create-guarded-component';

export type { ButtonProps } from 'antd';

export const Button = createGuardedComponent(AntdButton);
